import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "children", "tabIndex", "xmlns", "preserveAspectRatio"],
  _excluded2 = ["tabindex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { getAttributes } from '@carbon/icon-helpers';
import React from 'react';

/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Icon = /*#__PURE__*/React.forwardRef(function Icon(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    tabIndex = _ref.tabIndex,
    _ref$xmlns = _ref.xmlns,
    xmlns = _ref$xmlns === void 0 ? 'http://www.w3.org/2000/svg' : _ref$xmlns,
    _ref$preserveAspectRa = _ref.preserveAspectRatio,
    preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _getAttributes = getAttributes(_objectSpread(_objectSpread({}, rest), {}, {
      tabindex: tabIndex
    })),
    tabindex = _getAttributes.tabindex,
    attrs = _objectWithoutProperties(_getAttributes, _excluded2);
  var props = attrs;
  if (className) {
    props.className = className;
  }
  if (tabindex !== undefined && tabindex !== null) {
    if (typeof tabindex === 'number') {
      props.tabIndex = tabindex;
    } else {
      props.tabIndex = Number(tabIndex);
    }
  }
  if (ref) {
    props.ref = ref;
  }
  if (xmlns) {
    props.xmlns = xmlns;
  }
  if (preserveAspectRatio) {
    props.preserveAspectRatio = preserveAspectRatio;
  }
  return /*#__PURE__*/React.createElement('svg', props, children);
});
Icon.displayName = 'Icon';
export { Icon as default };